import React from 'react';
import { Heart, Moon, Flame, TrendingUp } from '@/utils/icons';
import { LucideIcon } from 'lucide-react';
import ReadinessScore from './ReadinessScore';

interface OverviewTabProps {
  athleteData: any;
  isDark: boolean;
  getValidatedStats: () => any;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ athleteData, isDark, getValidatedStats }) => {
  const validatedStats = getValidatedStats();

  return (
    <div className="space-y-6">
      {/* Readiness Score - Expanded by default */}
      <ReadinessScore 
        athleteId={athleteData?.athlete_info?.id} 
        isDark={isDark} 
        defaultExpanded={true}
      />

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {(() => {
          return [
            {
              title: 'Recovery Score',
              value: validatedStats?.recovery.latest_recovery ? `${validatedStats.recovery.latest_recovery.toFixed(0)}%` : 'N/A',
              subtitle: `Avg: ${validatedStats?.recovery.average_recovery ? validatedStats.recovery.average_recovery.toFixed(0) : 'N/A'}%`,
              Icon: Heart
            },
            {
              title: 'Sleep Quality',
              value: validatedStats?.sleep.latest_quality ? `${validatedStats.sleep.latest_quality.toFixed(0)}%` : 'N/A',
              subtitle: `${validatedStats?.sleep.latest_duration ? validatedStats.sleep.latest_duration.toFixed(1) : 'N/A'}h duration`,
              Icon: Moon
            },
            {
              title: 'Daily Strain',
              value: validatedStats?.activity.latest_strain ? `${validatedStats.activity.latest_strain.toFixed(1)}` : 'N/A',
              subtitle: `Avg: ${validatedStats?.activity.average_strain ? validatedStats.activity.average_strain.toFixed(1) : 'N/A'}`,
              Icon: Flame
            },
            {
              title: 'Data Points',
              value: validatedStats?.recovery.data_points.toString() || '0',
              subtitle: `${athleteData.data_summary.analysis_period_days} day period`,
              Icon: TrendingUp
            }
          ];
        })().map((stat, index) => {
          const iconColors = ['cgm-icon-recovery', 'cgm-icon-sleep', 'cgm-icon-strain', 'cgm-icon-data'];
          return (
            <div
              key={stat.title}
              className={`cgm-metric-card`}
            >
              <div className="flex items-center gap-3 mb-4">
                <stat.Icon className={`w-8 h-8 flex-shrink-0 ${iconColors[index]}`} />
                <div className="text-sm cgm-text-secondary font-medium">{stat.title}</div>
              </div>
              <div className="text-2xl font-bold theme-text-primary mb-1">{stat.value}</div>
              <div className="text-sm theme-text-secondary">{stat.subtitle}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OverviewTab;
